/**
 * Форма «Помощь в подборе обучения» — заявка в GetCourse.
 *
 * Этап 6 §0, группа 5. Перенесён инлайн-блок из
 * `inc/feedback-form.php:186` (98 строк, 77 живых).
 *
 * 🔴 Здесь цена ошибки выше, чем во всём остальном §0: это ЛИДЫ.
 * Сломайся сборка полей — страница останется визуально целой,
 * визуальный регресс будет зелёным, а заявки перестанут приходить.
 * Узнают об этом не из теста, а из падения продаж.
 *
 * Поэтому перенос сделан строго 1:1, а состав запроса снят замером
 * ДО правки (подмена `window.fetch`) и сверен ПОСЛЕ поле за полем:
 *   email, phone (с кодом страны), policy, policy_second,
 *   product_title[], offer_codes[], utm_source, utm_medium,
 *   utm_campaign, utm_content
 *
 * 🔴 Где используется — НЕ в содержимом записей, а в ШАБЛОНЕ:
 * [`single-cases_archive.php:198`](../../../single-cases_archive.php:198)
 * вызывает `do_shortcode('[feedback-form]')` жёстко, поэтому форма
 * есть на ВСЕХ записях CPT `cases_archive` — их 13.
 *
 * ⚠️ Это пятый канал использования, которого не было в моей первой
 * проверке. Я искал шорткод в `post_content`, нашёл его на двух
 * кейсах и решил, что носителей два. Владелец удалил эти два
 * вхождения — и форма осталась на месте, потому что настоящий
 * источник был в шаблоне. Те два вхождения оказались ДУБЛЕМ:
 * на страницах форма выводилась дважды.
 *
 * Отсюда правило: у шорткода проверяются ОБА канала — `post_content`
 * базы И вызовы `do_shortcode()` в шаблонах. Любой из них в
 * одиночку даёт неполную картину.
 *
 * Стили формы: `assets/css/archive-cases-detail.css`, 18 правил,
 * подключается из [`functions.php:621`](../../../functions.php:621).
 *
 * ⚠️ Шорткод лежит в `post_content` базы, а не в шаблонах.
 * `grep` по теме его НЕ находит — проверять запросом к БД,
 * иначе живая форма выглядит мёртвой.
 */

/** Идентификатор счётчика Яндекс.Метрики — как в исходнике. */
const METRICA_ID = 59852344;

/**
 * Значения UTM по умолчанию, когда их нет в адресе страницы.
 * Вынесены в таблицу: в исходнике это были четыре почти одинаковых
 * блока `if/else` на 16 строк.
 *
 * ⚠️ `utm_content` по умолчанию — путь страницы, поэтому считается
 * не здесь, а в момент сборки запроса.
 */
const UTM_DEFAULTS = {
    utm_source: 'seo',
    utm_medium: 'organic',
    utm_campaign: 'consultation_consultation',
};

/**
 * Запоминает источник перехода в `sessionStorage`.
 *
 * Перенесено как есть. Значение нигде в этом файле не читается —
 * его забирает `assets/js/script.js`. Убирать нельзя: ключ общий.
 */
function rememberSource() {
    if (!document.referrer) return;

    const host = document.referrer.split('/')[2];
    if (!host) return;

    // Берётся первая часть домена длиннее трёх символов:
    // для `yandex.ru` это `yandex`, для `www.google.com` — `google`
    const source = host.split('.').find((part) => part.length > 3);

    if (!sessionStorage.getItem('custom_source')) {
        sessionStorage.setItem('custom_source', source);
    }
}

/**
 * Код страны из intl-tel-input.
 *
 * 🔴 Читается в момент отправки, а не при инициализации — и это
 * важно. Библиотека грузится динамически
 * ([`intl-tel.js`](intl-tel.js:17)), и на момент навешивания
 * обработчика обёртки `.iti` может ещё не быть. К первому submit
 * она уже есть, поэтому гонки нет.
 *
 * Если обёртки нет, вернётся пустая строка — телефон уйдёт без
 * кода страны, как и в исходнике. Сознательно не меняю: это
 * поведение «до», а правка логики требует своей приёмки.
 */
function getDialCode(form) {
    const container = form.querySelector('.iti');
    const dial = container && container.querySelector('.iti__selected-dial-code');

    return dial ? dial.textContent.trim() : '';
}

/** Безопасный вызов цели: заглушка `window.ym` живёт в футере. */
function reachGoal(goal) {
    if (typeof window.ym === 'function') {
        window.ym(METRICA_ID, 'reachGoal', goal);
    }
}

/**
 * Сборка полей заявки.
 *
 * Порядок добавления сохранён из исходника: GetCourse на него
 * не смотрит, но сверка «ДО и ПОСЛЕ» идёт по списку пар,
 * и совпадающий порядок делает её читаемой.
 */
function buildFormData(form) {
    const params = new URLSearchParams(window.location.search);
    const data = new FormData();

    const dialCode = getDialCode(form);
    const phone = dialCode + form.querySelector('input[type="tel"]').value;

    data.set('email', form.querySelector('input[type="email"]').value);
    data.set('phone', phone);

    const policy = document.querySelector('#feedback-form__policy');
    const policySecond = document.querySelector('#feedback-form__policy-sec');

    data.append('policy', policy.checked ? 'checked' : '');
    data.append('policy_second', policySecond.checked ? 'checked' : '');
    data.append('product_title[]', 'Помощь в подборе обучения');
    data.append('offer_codes[]', '5271553');

    for (const [key, fallback] of Object.entries(UTM_DEFAULTS)) {
        data.append(key, params.get(key) || fallback);
    }
    data.append('utm_content', params.get('utm_content') || location.pathname);

    return data;
}

/** Подсветка блока согласия на 30 секунд — время из исходника. */
function highlightPolicy() {
    const label = document.querySelector('.feedback-form__checkbox-list label');
    if (!label) return;

    label.classList.add('form-noty__conditions');
    setTimeout(() => {
        label.classList.remove('form-noty__conditions');
    }, 30_000);
}

async function submitForm(form) {
    const response = await fetch('/gc/gc-post.php', {
        method: 'POST',
        body: buildFormData(form),
    });

    // Ответ GetCourse в исходнике писался в консоль. Оставлен:
    // по нему отлаживают приём заявок на проде
    console.log(await response.text());

    const block = document.querySelector('.feedback-form__block');
    if (block) {
        block.innerHTML =
            '<div class="feedback-form__section-success">Ваша заявка отправлена!' +
            ' Менеджер свяжется с вами в ближайшее время!</div>';
    }

    reachGoal('lead-forma-case');
}

export default function FeedbackForm() {
    const form = document.querySelector('.feedback-form');
    if (!form) return;

    rememberSource();
    reachGoal('pokaz-forma-case');

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        const policy = document.querySelector('#feedback-form__policy');

        // Без согласия заявка не уходит — проверено замером:
        // запросов на gc-post.php ноль, появляется подсветка
        if (!policy.checked) {
            highlightPolicy();
            return;
        }

        submitForm(form).catch((error) => {
            console.error('feedback-form: заявка не отправлена', error);
        });
    });
}
